import { Link } from "react-router-dom";

const projects = [
  {
    imgSrc: "/images/tentacle-explorer.png",
    href: "/portfolio/project-cyberscape",
    bgClass: "bg-gradient-to-br from-purple-900/40 via-[#1a0a2e] to-[#0a0a0a]",
  },
  {
    imgSrc: "/images/serpents-kiss.png",
    href: "/portfolio/ethereal-threads",
    bgClass: "bg-[#0a0a0a]",
  },
  {
    imgSrc: "/images/quantum-leap-card.png",
    href: "/portfolio/quantum-leap",
    bgClass: "bg-[#0a0a0a]",
  },
  {
    imgSrc: "/images/quantum-leap.png",
    href: "/audio-visualizer",
    bgClass: "bg-gradient-to-br from-fuchsia-900/30 via-[#0a0414] to-[#04030a]",
  },
];

export function Portfolio() {
  return (
    <div id="portfolio" className="relative py-20 px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {projects.map((project) => (
          <Link key={project.imgSrc} to={project.href} aria-hidden tabIndex={-1}>
            <div className={`group relative block w-full h-[450px] overflow-hidden rounded-lg shadow-lg cursor-pointer ${project.bgClass}`}>
              <img
                src={project.imgSrc}
                alt=""
                className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-110"
              />
              {/* Graffiti-style text overlay for Quantum Leap */}
              {project.label && (
                <div className="absolute inset-0 flex items-end justify-start p-5 pb-7">
                  <span
                    className="text-white/70 font-bold tracking-tight lowercase
                      text-2xl sm:text-3xl
                      drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]
                      -rotate-[3deg] origin-left
                      group-hover:text-white/90 transition-colors duration-500"
                    style={{ fontFamily: "'Segoe UI', 'Helvetica Neue', system-ui, sans-serif", fontStyle: 'italic' }}
                  >
                    {project.label}
                  </span>
                </div>
              )}
            </div>
          </Link>
        ))}
      </div>

      {/* Curator portrait — bigger, more breathing room */}
      <div className="max-w-7xl mx-auto mt-28 flex flex-col items-center">
        <img
          src="/images/curator.png"
          alt=""
          aria-hidden
          className="w-[130px] h-[130px] sm:w-[160px] sm:h-[160px] rounded-full object-cover border border-white/15 shadow-md shadow-purple-900/20"
          loading="lazy"
        />
      </div>
    </div>
  );
}
